import { render } from "./acctrans-apply.vue?vue&type=template&id=6ff9977d&scoped=true"
import script from "./acctrans-apply.vue?vue&type=script&lang=js"
export * from "./acctrans-apply.vue?vue&type=script&lang=js"

import "./acctrans-apply.vue?vue&type=style&index=0&id=6ff9977d&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ff9977d"]])

export default __exports__